// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"GK-z","carousel":"HK-z"};